import { Link as RouterLink } from 'react-router-dom'
import styled, { css } from 'styled-components'

import { buttonStyles } from '../button/button.styled'
import { LinkSizeKeys, LinkUseKeys } from './link.types'

// NOTE: Link is mostly a complete replica of a `Button` but as a separate component for better TS coverage
export const Link = styled(RouterLink)<{
  $use: LinkUseKeys
  $size: LinkSizeKeys
  $onlyBox?: boolean
  $onlyCircle?: boolean
  $overrideDisabled?: boolean
}>(({ theme, $use, $size, $onlyBox, $onlyCircle, $overrideDisabled }) =>
  buttonStyles(theme, $use, $size, $onlyBox, $onlyCircle, $overrideDisabled),
)

export const ChildrenWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['4']};
  `,
)
